// 基础URL
export const BASE_URL = "https://mon.shanhe.link/";
// export const BASE_URL = "http://127.0.0.1:8818/";
// export const BASE_URL = "http://192.168.3.24:98/";


// 获取头像路径
export const GET_USER_INFO_API = BASE_URL + "images/";

// 获取websocket地址
export const GET_WEB_SOCKET_API = "wss://mon.shanhe.link/";
// export const GET_WEB_SOCKET_API = "ws://127.0.0.1:8818/";
// export const GET_WEB_SOCKET_API = "wss://192.168.3.24:8889/";